<template>
	<span
		v-if="label"
		class="app-version"
		data-test-id="text-app-version"
	>{{ label }}</span>
</template>

<script>
export default {
	name: 'BaseAppVersion',

	computed: {
		label() {
			// Injected at build time from package.json (see vue.config.js).
			// Renders nothing rather than "vundefined" when it is missing.
			const version = process.env.VUE_APP_VERSION;

			return version ? `v${version}` : '';
		},
	},
};
</script>

<style lang="scss" scoped>
.app-version {
	position: fixed;
	right: 20px;
	bottom: 20px;
	z-index: 9999;
	color: $color-black;
	font-size: rem(14);
	line-height: 1;
	// Left selectable on purpose so it can be copied into a bug report.
	opacity: 0.3;
	white-space: nowrap;
}
</style>
